import React from 'react';
import { ArrowRight } from 'lucide-react';
import PageNavbar from '../../layouts/PageNavbar/PageNavbar';
import LukIAVoiceHero from '../../components/custom/LukIA/LukIAVoiceHero';
import IAChatDemo from '../../components/custom/LukIA/IAChatDemo';
import IAPredictionStage from '../../components/custom/LukIA/IAPredictionStage';
import IAHealthMonitor from '../../components/custom/LukIA/IAHealthMonitor';
import IAMarginInsights from '../../components/custom/LukIA/IAMarginInsights';
import IAFeaturesBento from '../../components/custom/LukIA/IAFeaturesBento';
import { motion } from 'framer-motion';
import TrainingSection from '../../components/custom/TrainingSection/TrainingSection';

function IAPage() {
  return (
    <div className="bg-white min-h-screen">
      <LukIAVoiceHero />
      <IAChatDemo />
      <IAPredictionStage />
      <IAHealthMonitor />
      <IAMarginInsights />
      <IAFeaturesBento />
      
      <TrainingSection 
        badge="Implementação LukIA Premium"
        title1="Implemente a inteligência"
        title2="que move o seu posto."
        description="Aumente seus resultados com a LukIA. Nossos especialistas guiam você na configuração de alertas preditivos, análise de margens em tempo real e automação total da sua retaguarda."
        serviceType="ia"
      />

      <div className="py-20 flex justify-center bg-white border-t border-slate-100">
        <motion.button 
          whileHover={{ scale: 1.05, y: -5 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className="group relative flex items-center gap-3 bg-slate-900 text-white px-10 py-5 rounded-2xl font-black shadow-[0_20px_40px_-10px_rgba(0,0,0,0.2)] transition-all duration-500 uppercase tracking-[0.15em] text-xs overflow-hidden"
        >
          <div className="absolute inset-0 bg-gradient-to-r from-purple-600 to-blue-600 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
          <span className="relative z-10">Voltar ao topo</span>
          <ArrowRight className="relative z-10 w-4 h-4 transition-transform duration-500 group-hover:translate-x-1" />
        </motion.button>
      </div>
    </div>
  );
}

export default IAPage;
